import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { getEasing } from "../../utils/getEasing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
const ICON_WIDTH = '24px';
const getStateColor = (props, color = 'default') => {
    if (props.disabled)
        return props.theme.colors.interaction.secondary.disabled;
    if (props.invalid)
        return props.theme.colors.ui.error;
    return props.theme.colors.interaction.secondary[color];
};
export const StyledIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledIcon", componentId: "auir-611444a-1uvitky" }) `
  grid-row: 1;
  grid-column: icon;

  width: ${ICON_WIDTH};
  height: ${ICON_WIDTH};

  *:focus-within > & {
    padding-block-end: ${(props) => `var(${props.theme.responsive.spacing.xxs})`};

    transform: rotateZ(180deg);
  }
  *:not(:focus-within) > & {
    padding-block-start: ${(props) => `var(${props.theme.responsive.spacing.xxs})`};
  }

  pointer-events: none;
`;
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-o76dpz" }) `
  --select-icon-padding: calc(
    ${ICON_WIDTH} + ${(props) => `var(${props.theme.responsive.spacing.xs})`}
  );

  padding-inline-end: var(--select-icon-padding);

  ${injectSpacing('margin')}
`;
export const StyledSelectContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledSelectContainer", componentId: "auir-611444a-oz9zvj" }) `
  display: grid;
  grid-template-columns: [start] auto [icon] ${ICON_WIDTH} [end];
  margin-inline-end: calc(-1 * var(--select-icon-padding));

  ${(props) => !props.readOnly &&
    css `
      &::after {
        grid-column: start / end;
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 2px;
        margin-top: -1px;
        border-bottom-color: var(${getStateColor(props)});
        border-bottom-width: 1px;
        border-bottom-style: solid;
        transition-timing-function: ${props.theme.easing};
        transition-duration: 0.25s;
        transition-property: border-bottom-color, background-color;
        content: '';
      }

      ${!props.disabled &&
        css `
        &:focus-within::after {
          background-color: ${(props) => `var(${getStateColor(props, 'focus')})`};
          border-bottom-color: ${(props) => `var(${getStateColor(props, 'focus')})`};
        }

        &:hover::after,
        *:hover ~ &::after {
          border-bottom-color: ${(props) => `var(${getStateColor(props, 'hover')})`};
        }
      `}
    `}

  color: var(
    ${(props) => props.disabled
    ? props.theme.colors.interaction.secondary.disabled
    : props.theme.colors.interaction.secondary.default}
  );

  &:hover {
    color: var(
      ${(props) => props.disabled
    ? props.theme.colors.interaction.secondary.disabled
    : props.theme.colors.interaction.secondary.hover}
    );
  }
`;
export const StyledSelect = styled.select.withConfig({ displayName: "auir-611444a-StyledSelect", componentId: "auir-611444a-1gtnnp8" }) `
  all: revert;

  display: block;
  grid-row: 1;
  grid-column: start / end;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding-block-start: ${(props) => `var(${props.theme.responsive.spacing.xxs})`};
  padding-block-end: ${(props) => `var(${props.theme.responsive.spacing.xs})`};
  padding-inline-end: var(--select-icon-padding);

  color: var(${(props) => props.theme.colors.interaction.secondary.filled});
  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}

  background-color: transparent;
  border: none;
  cursor: pointer;
  opacity: ${(props) => (props.empty ? 0 : 1)};

  transition-timing-function: var(${getEasing});
  transition-duration: 0.25s;
  transition-property: opacity;

  appearance: none;

  &:focus {
    opacity: 1;
  }

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.secondary.hover});
  }

  &:disabled {
    color: var(
      ${(props) => props.readOnly
    ? props.theme.colors.interaction.secondary.readonly
    : props.theme.colors.interaction.secondary.disabled}
    );

    cursor: ${(props) => (props.readOnly ? 'default' : 'not-allowed')};
  }

  option {
    all: revert;
    color: initial;
  }

  option[disabled] {
    color: unset;
  }
`;
//# sourceMappingURL=Select.styles.mjs.mjs.map